export const PUBLIC_KEY = "fvy64qrWkwZnR2Qi7";
export const CONTACT_SERVICE_ID = "service_k82wzyc";
export const CONTACT_TEMPLATE_ID = "template_opplg4n";
export const REVIEWS_SERVICE_ID = "service_1c9lyom";
export const REVIEWS_TEMPLATE_ID = "template_98g7scp";
